import { PaletteColorOptions, ThemeOptions } from '@mui/material'
import { createTheme as createMuiTheme, Theme } from '@mui/material/styles'
import React from 'react'
import { components, typography } from './themeConstants'

const getMuiTheme = (theme: ThemeOptions | undefined): Theme =>
  createMuiTheme({
    ...typography,
    ...components,
    ...theme,
  })

declare module '@mui/material/styles' {
  interface CustomPalette {
    adminButton: PaletteColorOptions
    userButton: PaletteColorOptions
  }
  type Palette = CustomPalette
  type PaletteOptions = CustomPalette
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    adminButton: true
    userButton: true
  }
}

declare module '@mui/material/styles' {
  interface TypographyVariants {
    boldTextXlarge: React.CSSProperties
    textXlarge: React.CSSProperties
    boldTextLarge: React.CSSProperties
    boldTextSmall?: React.CSSProperties
    textMedium?: React.CSSProperties
    textLarge: React.CSSProperties
    bodyBold?: React.CSSProperties
    bodyRegular?: React.CSSProperties
    labelBold?: React.CSSProperties
    labelRegular?: React.CSSProperties
    boldTextMedium: React.CSSProperties
    textSmall: React.CSSProperties
    boldText45: React.CSSProperties
  }

  // allow configuration using `createTheme`
  export interface TypographyVariantsOptions {
    boldTextXlarge: React.CSSProperties
    textXlarge: React.CSSProperties
    boldTextLarge?: React.CSSProperties
    boldTextSmall?: React.CSSProperties
    textMedium?: React.CSSProperties
    textLarge: React.CSSProperties
    bodyBold?: React.CSSProperties
    bodyRegular?: React.CSSProperties
    labelBold?: React.CSSProperties
    labelRegular?: React.CSSProperties
    boldTextMedium: React.CSSProperties
    textSmall: React.CSSProperties
    boldText45: React.CSSProperties
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    boldTextXlarge: true
    textXlarge: true
    boldTextLarge: true
    boldTextSmall: true
    textMedium: true
    textLarge: true
    bodyBold: true
    bodyRegular: true
    labelBold: true
    labelRegular: true
    boldTextMedium: true
    textSmall: true
    boldText45: true
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    submitFormButton: true
    dashed: true
  }
}

declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    accordionNormal: true
    accordionOutlined: true
  }
}

declare module '@mui/material/TextField' {
  interface TextFieldPropsVariantOverrides {
    withIcon: true
  }
}

declare module '@mui/material/Select' {
  interface SelectPropsVariantOverrides {
    headerDropdown: true
  }
}

export default getMuiTheme
